'use strict';

angular.module('admin', [
    'ng-komondor',
])

/**
 * Create the admin state
 */
.config(function ($stateProvider)
{
    $stateProvider
        .state('admin', {
            abstract: true,
            url: '/admin',
            views: {
                header: {
                    templateUrl: 'modules/header/header.html',
                    controller: 'HeaderCtrl'
                },
                '': {
                    templateUrl: 'admin/admin.html'
                }
            },
            resolve: {

            }
        });
})

/**
 * Disallow admin states without gate
 */
.run(function ($rootScope, kdGate, notify)
{
    $rootScope.$on('$stateChangeStart', function ($event, state)
    {
        if (/^admin./.test(state.name) && !kdGate.check('admin')) {
            $event.preventDefault();

            notify.alert('Access denied.');
        }
    });
})

.config(function ($provide)
{
    $provide.decorator('getBreadcrumbs', function getBreadcrumbsDecorator($delegate)
    {
        return function (stateOptions, params, crumbGo)
        {
            if (!stateOptions.customBreadcrumb) {
                return $delegate(stateOptions, params, crumbGo);
            }

            var crumbsCopy = angular.copy(stateOptions.customBreadcrumb);
            var last = crumbsCopy.pop();

            return {
                title: last.name,
                list: crumbsCopy,
            };
        };
    });
});
